export default (zones = []) => zones.length <= 1;
